<script lang="ts">
	import { twMerge, type ClassNameValue } from "tailwind-merge";
	import P from "#lib/components/P.svelte";
	import Toggle from "#lib/components/Toggle.svelte";
	import type { Snippet } from "svelte";

	interface Props {
		label: string;
		description?: string;
		enabled?: boolean;
		class?: ClassNameValue;
		titleClass?: ClassNameValue;
		bodyClass?: ClassNameValue;
		enabledClass?: ClassNameValue;
		toggleOnTitleClick?: boolean;
		accessory?: Snippet;
		icon?: Snippet;
		title?: Snippet;
		control?: Snippet<[boolean, () => void]>;
		children?: Snippet;
		onchange?: (enabled: boolean) => void;
	}

	let { label, description, enabled = true, class: className = "", titleClass = "", bodyClass = "", enabledClass = "", toggleOnTitleClick = false, onchange, accessory, icon, title, control, children }: Props = $props();

	export function toggle() {
		enabled = !enabled;
		onchange?.(enabled);
	}

	function handleTitleClick(e: MouseEvent) {
		e.preventDefault();
		e.stopImmediatePropagation();
		if (toggleOnTitleClick) {
			toggle();
		}
	}

	function handleTitleKey(e: KeyboardEvent) {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			e.stopImmediatePropagation();
			toggle();
		}
	}
</script>

<div class={twMerge(toggleOnTitleClick && "cursor-pointer", className, enabled && enabledClass)}>
	<div class={twMerge("flex w-full items-center gap-4 rounded-t-lg border-t border-r border-l border-gray-200 bg-gray-50 px-4 py-3.5 text-left font-medium", titleClass)} role="button" tabindex="0" onkeydown={handleTitleKey} onclick={handleTitleClick}>
		{@render accessory?.()}
		{@render icon?.()}
		<div class="flex w-full items-center justify-between">
			{#if title}
				{@render title?.()}
			{:else}
				<div class="flex grow flex-col">
					<P>{label}</P>
					{#if description}
						<P size="sm" secondary>{description}</P>
					{/if}
				</div>
			{/if}
		</div>
		{#if control}
			{@render control?.(enabled, toggle)}
		{:else}
			<div class="text-right">
				<Toggle checked={enabled} on:change={toggle} />
			</div>
		{/if}
	</div>
	<div class={twMerge("rounded-b-lg border border-gray-200 bg-white", bodyClass)} class:hidden={!enabled} class:p-6={enabled}>
		{@render children?.()}
	</div>
</div>
